import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const StorybookWrapper = styled.div`
  width: 500px;
`;
